import bootstrap from 'bootstrap';

export default function initAccordionScrolling () {
  const matchMobile = window.matchMedia('(max-width: 767px)');

  document.querySelectorAll('.accordion').forEach(function(holder) {
    const items = holder.querySelectorAll('.accordion-item');

    items.forEach(item => {
      const collapse = item.querySelector('.accordion-collapse')

      collapse.addEventListener('shown.bs.collapse', event => {
        if(matchMobile.matches) {
          const height = document.querySelector('.header').clientHeight;
          if(item.getBoundingClientRect().y < height ) {
            window.scrollTo({
              top: item.offsetTop,
              behavior: "smooth",
            });
          }
        }
      })
    })
  });

  document.querySelectorAll('.tab-content').forEach(function(holder) {
    const tabs = holder.querySelectorAll('.tab-pane');
    tabs.forEach(function (tab){
      for (const child of tab.children) {
        if(child.classList.contains('accordion-collapse')) {
          console.log(child)
          child.addEventListener('shown.bs.collapse', event => {
            console.log('show')
            if(matchMobile.matches) {
              const height = document.querySelector('.header').clientHeight;
              if(tab.getBoundingClientRect().y < height ) {
                window.scrollTo({
                  top: tab.offsetTop,
                  behavior: "smooth",
                });
              }
            }
          });
        }
      }
    })
  })
}